import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

axios.defaults.baseURL =
  "https://data.opendatasoft.com/api/records/1.0/search/";

export default new Vuex.Store({
  state: {
    entreprises: [],
    entreprisesMember: [],
    entreprisesToShow: [],
    categories: [],
    categoriesSelected: [],
    markers: [],
    markerActive: null,
    entreprisePage: null,
    showList: true,
  },

  getters: {
    entreprises: (state) => {
      return state.entreprisesToShow;
    },
    categories: (state) => {
      return state.categories;
    },
    markers: (state) => {
      return state.markers;
    },
    entreprisePage: (state) => {
      return state.entreprisePage;
    },
  },

  mutations: {
    SET_MEMBER_ENTREPRISES(state, memberEntreprises) {
      state.entreprisesMember = memberEntreprises;
    },
    SET_ENTREPRISES(state, entreprises) {
      // check if entreprise is a member
      // function isMember(siret) {
      //   return state.entreprisesMember.includes(
      //     state.entreprisesMember.find(
      //       (entreprise) => entreprise.acf.entreprise_siret === siret
      //     )
      //   );
      // }

      // get the member entreprise's activity
      // function getActivite(siret) {
      //   let member = state.entreprisesMember.find(
      //     (entreprise) => entreprise.acf.entreprise_siret === siret
      //   );
      //   if (member) {
      //     return member.acf.secteur_activite;
      //   } else {
      //     return null;
      //   }
      // }

      // get the member logo
      // function getLogo(siret) {
      //   let member = state.entreprisesMember.find(
      //     (entreprise) => entreprise.acf.entreprise_siret === siret
      //   );
      //   if (member) {
      //     return member.acf.logo;
      //   } else {
      //     return null;
      //   }
      // }

      // add the entreprises from the API to the entreprises array
      entreprises.forEach((entreprise) => {
        let numero = null;
        if (entreprise.fields.numerovoieetablissement) {
          numero = entreprise.fields.numerovoieetablissement.toString();
          if (entreprise.fields.indicerepetitionetablissement) {
            numero += entreprise.fields.indicerepetitionetablissement;
          }
        } else if (entreprise.fields.complementadresseetablissement) {
          if (entreprise.fields.complementadresseetablissement.length <= 4) {
            numero = entreprise.fields.complementadresseetablissement
              .split(" ")
              .join("");
          }
        }
        if (numero === "9A") {
          entreprise.fields.geolocetablissement = [
            48.60392665481421,
            7.680934626621749,
          ];
        }
        if (numero === "9B") {
          entreprise.fields.geolocetablissement = [
            48.60360947927873,
            7.6812437499021335,
          ];
        }
        let adresse = null;
        if (
          numero &&
          entreprise.fields.typevoieetablissement &&
          entreprise.fields.libellevoieetablissement
        ) {
          adresse =
            numero.toLowerCase() +
            " " +
            entreprise.fields.typevoieetablissement.toLowerCase() +
            " " +
            entreprise.fields.libellevoieetablissement.toLowerCase();
        } else if (numero) {
          adresse = numero + " rue du parc";
        } else {
          adresse = entreprise.fields.adresseetablissement;
        }

        state.entreprises.push({
          title: entreprise.fields.denominationunitelegale,
          slug: entreprise.fields.denominationunitelegale
            .split(" ")
            .join("-")
            .toLowerCase(),
          siret: entreprise.fields.siret,
          l1_adressage_unitelegale: entreprise.fields.l1_adressage_unitelegale,
          section: entreprise.fields.classeetablissement,
          adresse: adresse,
          adresseSlug: adresse
            .split(" ")
            .join("-")
            .toLowerCase(),
          numerovoieetablissement: numero,
          geolocetablissement: entreprise.fields.geolocetablissement,
          member: false,
        });
      });

      // add the rest of the entrepriseMember to the entreprises array
      // console.log(state.entreprisesMember);
      // console.log(state.entreprises);
      state.entreprisesMember.forEach((entreprise) => {
        if (
          !state.entreprises.find(
            (ent) => ent.siret === entreprise.acf.entreprise_siret
          )
        ) {
          state.entreprises.push({
            title: entreprise.title.rendered,
            slug: entreprise.slug,
            siret: entreprise.acf.entreprise_siret,
            l1_adressage_unitelegale: null,
            section: entreprise.acf.secteur_activite,
            adresse: entreprise.acf.adresse,
            adresseSlug: entreprise.acf.adresse
              .split(" ")
              .join("-")
              .toLowerCase(),
            numerovoieetablissement: null,
            geolocetablissement: null,
            member: true,
            member_activite: entreprise.acf.secteur_activite,
            member_logo: entreprise.acf.logo_entreprise,
          });
        } else {
          // console.log(entreprise);
          let entrepriseToUpdate = state.entreprises.find(
            (ent) => ent.siret === entreprise.acf.entreprise_siret
          );
          entrepriseToUpdate.slug = entreprise.slug;
          entrepriseToUpdate.member = true;
          entrepriseToUpdate.member_activite = entreprise.acf.secteur_activite;
          entrepriseToUpdate.member_logo = entreprise.acf.logo_entreprise;
        }
      });

      // sort by alphabetical order
      function sortAlphabetical(a, b) {
        if (a.title < b.title) {
          return -1;
        }
        if (a.title > b.title) {
          return 1;
        }
        return 0;
      }
      state.entreprises.sort(sortAlphabetical);

      // put member entreprises first
      state.entreprises.sort((a, b) => {
        if (a.member === b.member) {
          return 0;
        }
        if (a.member) {
          return -1;
        }
        return 1;
      });
      state.entreprisesToShow = state.entreprises;
    },

    SET_MARKERS(state) {
      state.entreprises.forEach((entreprise) => {
        if (entreprise.numerovoieetablissement) {
          if (
            !state.markers.find(
              (marker) => marker.number === entreprise.numerovoieetablissement
            )
          ) {
            if (
              !state.markers.find(
                (marker) => marker.lat === entreprise.geolocetablissement[0]
              ) &&
              !state.markers.find(
                (marker) => marker.lng === entreprise.geolocetablissement[1]
              )
            ) {
              if (entreprise.numerovoieetablissement !== "29") {
                state.markers.push({
                  number: entreprise.numerovoieetablissement,
                  lat: entreprise.geolocetablissement[0],
                  lng: entreprise.geolocetablissement[1],
                  adresse: entreprise.adresse,
                  slug: entreprise.adresseSlug,
                });
              }
            }
          }
        }
      });
      state.markers.sort(function(a, b) {
        return a.number - b.number;
      });
    },

    SET_CATEGORIES(state, categories) {
      categories.forEach((category) => {
        state.categories.push({
          name: category.name,
        });
      });
      // sort by alphabetical order
      function sortAlphabetical(a, b) {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      }
      state.categories.sort(sortAlphabetical);
    },

    SET_ACTIVE_MARKER(state, markerActive) {
      state.markerActive = markerActive;
    },

    SET_SELECTED_CATEGORIES(state, categoriesSelected) {
      state.categoriesSelected = categoriesSelected;
    },

    FILTER_ENTREPRISES(state) {
      //reset
      state.entreprisesToShow = state.entreprises;
      //filter by marker
      if (state.markerActive) {
        state.entreprisesToShow = state.entreprisesToShow.filter(
          (entreprise) => {
            return entreprise.adresseSlug === state.markerActive;
          }
        );
      }
      //filter by categories
      if (state.categoriesSelected.length > 0) {
        state.entreprisesToShow = state.entreprisesToShow.filter(
          (entreprise) => {
            return state.categoriesSelected.includes(
              state.categoriesSelected.find(
                (category) => category.name === entreprise.section
              )
            );
          }
        );
      }
    },

    SET_ENTREPRISE_PAGE(state, entreprise) {
      state.entreprisePage = entreprise;
    },
    toggleList(state) {
      state.showList = !state.showList;
    },
  },

  actions: {
    async loadMemberEntreprises({ commit }) {
      try {
        const response = await axios.get(
          "https://interval-strasbourg.eu/wp-json/wp/v2/entreprises"
        );
        commit("SET_MEMBER_ENTREPRISES", response.data);
      } catch (error) {
        console.log(error);
      }
    },
    async loadEntreprises({ dispatch, commit }) {
      await dispatch("loadMemberEntreprises");
      try {
        const response = await axios.get(
          "?dataset=base-sirene-v3-consolidee-sur-l-eurometropole-de-strasbourg%40eurometrostrasbourg&q=&rows=-1&facet=classeetablissement&facet=numerovoieetablissement&refine.libellecommuneetablissement=OBERHAUSBERGEN&refine.etatadministratifetablissement=Actif&refine.libellevoieetablissement=DU+PARC&exclude.activiteprincipaleetablissement=68.20A&exclude.activiteprincipaleetablissement=68.20B&exclude.activiteprincipaleetablissement=41.10D&exclude.naturejuridiqueunitelegale=Entrepreneur+individuel&timezone=Europe%2FParis"
        );
        commit("SET_ENTREPRISES", response.data.records);
        commit("SET_MARKERS");
        commit("SET_CATEGORIES", response.data.facet_groups[0].facets);
        commit("FILTER_ENTREPRISES");
      } catch (error) {
        console.log(error);
      }
    },

    filterEntreprisesByMarker({ commit }, markerAdresse) {
      commit("SET_ACTIVE_MARKER", markerAdresse);
      commit("FILTER_ENTREPRISES");
    },

    filterEntreprisesByCategories({ commit }, categoriesSelected) {
      commit("SET_SELECTED_CATEGORIES", categoriesSelected);
      commit("FILTER_ENTREPRISES");
    },

    // get single entreprise
    async getEntreprise({ commit }, entrepriseSlug) {
      try {
        const response = await axios.get(
          `https://interval-strasbourg.eu/wp-json/wp/v2/entreprises?slug=${entrepriseSlug}&_embed`
        );
        commit("SET_ENTREPRISE_PAGE", response.data[0]);
      } catch (error) {
        console.log(error);
      }
    },
  },
});
